import React from "react";

interface FiltersArborescenceProps {
  setStatus: (newvalue: string) => void;
  status: string;
  searchQuery: string;
  handleSearchChange: any;
  setFilterBar: (newvalue: boolean) => void;
  filterBar: boolean;
  setSelectedFormat: (newvalue: string) => void;
  setSelectedUnités: any;
}
const FiltersArborescence = ({
  setStatus,
  status,
  searchQuery,
  handleSearchChange,
  setFilterBar,
  filterBar,  
  setSelectedFormat,
  setSelectedUnités,
}: FiltersArborescenceProps) => {
  return (
    <div className="mt-6 md:flex md:items-center md:justify-between">
      <div
        role="group"
        className="inline-flex overflow-hidden bg-white border divide-x rounded-lg  rtl:flex-row-reverse  "
      >
        <div>
          <button
            onClick={() => setStatus("gexpertise")}
            type="button"
            className={`px-5 py-2 text-md font-medium  ${
              status == "gexpertise"
                ? "text-white bg-gexpertise-200"
                : "text-gexpertise-200 bg-transparent border border-gexpertise-200"
            } rounded-l-lg hover:bg-gexpertise-200 hover:text-white focus:z-10 focus:ring-2 focus:ring-gexpertise-100 focus:bg-gexpertise-200 focus:text-white  `}
          >
            Arborescence Gexpertise
          </button>
          <button
            onClick={() => setStatus("fidji")}
            type="button"
            className={`px-5 py-2 text-md font-medium  ${
              status == "fidji"
                ? "text-white bg-gexpertise-200"
                : "text-gexpertise-200 bg-transparent border border-gexpertise-200"
            } rounded-r-lg hover:bg-gexpertise-200 hover:text-white focus:z-10 focus:ring-2 focus:ring-gexpertise-100 focus:bg-gexpertise-200 focus:text-white  `}
          >
            Arborescence Fidji
          </button>
        </div>
      </div>
      <div className="flex space-x-2">
        <form
          className="flex items-center"
          onSubmit={(e) => e.preventDefault()}
        >
          <label htmlFor="simple-search" className="sr-only">
            Search
          </label>

          <div className="relative w-full">
            <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
              <svg
                aria-hidden="true"
                className="w-5 h-5 text-gray-500 "
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
                  clipRule="evenodd"
                ></path>
              </svg>
            </div>
            <input
              type="text"
              id="simple-search"
              className="block p-2 pl-10 pr-10 text-md text-gray-900 border border-gray-300 rounded-lg w-80  focus:ring-gexpertise-200 focus:border-gexpertise-200 "
              placeholder="Recherche"
              value={searchQuery}
              onChange={handleSearchChange}
            ></input>
            {searchQuery && (
              <button
                type="button"
                aria-label="Effacer la recherche"
                onClick={() =>
                  handleSearchChange({ target: { value: "" } })
                }
                className="absolute inset-y-0 right-0 flex items-center pr-3 text-gray-500 hover:text-gray-700"
              >
                <svg
                  aria-hidden="true"
                  className="w-4 h-4"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            )}
          </div>
        </form>
        <button
          onClick={() => {
            setFilterBar(!filterBar);
            
            setSelectedFormat("");
            setSelectedUnités([]);
          }}
          className="flex items-center justify-center px-5 py-2 text-md text-gray-700 transition-colors duration-200 bg-white border rounded-lg gap-x-2 sm:w-auto  hover:bg-gray-100 "
        >
          <img src="/images/sort.png" />
          Filtres
        </button>
      </div>
    </div>
  );
};

export default FiltersArborescence;